import {
  ChevronLeftIcon,
  ChevronRightIcon,
  Typography,
} from '@iheartjane/reefer';
import { clsx } from 'clsx';

import styles from './imagePagination.module.css';

type ImagePaginationProps = {
  activeIndex: number;
  overridePosition?: 'top' | 'bottom';
  totalItems: number;
  updateIndex: (index: number) => void;
};

export function ImagePagination({
  activeIndex,
  overridePosition,
  totalItems,
  updateIndex,
}: ImagePaginationProps) {
  const nextIndex = (activeIndex + 1) % totalItems;
  const prevIndex = (activeIndex + totalItems - 1) % totalItems;

  return (
    <div className={styles['imagePagination']}>
      {/** @todo use elements with appropriate role */}
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div
        className={clsx(styles['buttonWrapper'], styles['rightButtonWrapper'])}
        onClick={() => updateIndex(prevIndex)}
      >
        <ChevronLeftIcon altText="View previous item" color="grays-white" />
      </div>

      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div
        className={clsx(styles['buttonWrapper'], styles['leftButtonWrapper'])}
        onClick={() => updateIndex(nextIndex)}
      >
        <ChevronRightIcon altText="View next item" color="grays-white" />
      </div>

      <div
        className={clsx(
          styles['paginationTextWrapper'],
          styles['paginationTextWrapperPosition'],
          overridePosition &&
            styles[`paginationTextWrapperPosition-${overridePosition}`]
        )}
      >
        <Typography variant="small-body-regular" color="grays-white">
          {activeIndex + 1}&#47;{totalItems}
        </Typography>
      </div>
    </div>
  );
}
